<template>
    <div class="o-search search">
        <div class="search__container">
            <OContentHeader
                class="search__header"
                icon="search"
                :title="$t('ui.search-category')"
            />
            <OTiles
                v-if="getItems.length"
                :items="getItems"
                :items-per-block="12"
                @tileClick="handleTileClick"
            >
                <template #default="{ button }">
                    <OTTile
                        v-if="t(button, 'type') === 'tenant' || t(button, 'type') === 'service'"
                        :item="getDenormalisedObjectById(button.id)"
                    />
                    <OServicesTile
                        v-else
                        :icon-src="button.files.icon"
                        :name="t(button, 'name')"
                        :objects-count="button.objectsCount"
                    />
                </template>
            </OTiles>
            <section
                v-else
                class="search__no-result"
            >
                <h3 class="search__no-result-header">{{$t('ui.terminal-search-no-result-header')}}</h3>
                <p class="search__no-result-text">{{$t('ui.terminal-search-no-result-text')}}</p>
            </section>
        </div>
        <div class="search__keyboard-block">
            <ABackButton
                route="start"
                :text="$t('ui.back')"
            />
            <div class="search__wrapper">
                <MInputForm
                    :value="searchValue"
                    :placeholder="$t('o-search_placeholder')"
                    @onDelete="handleDelete"
                >
                    <template #icon>
                        <svg-icon
                            original
                            name="icons/search-without-box"
                            class="search__input-icon"
                        />
                    </template>
                </MInputForm>
                <OKeyboard
                    @onKeyCLick="handleKeyboardClick"
                />
            </div>
            <MVersions />
        </div>
    </div>
</template>

<script>
import Fuse from "fuse.js";

import {
    mapState,
    mapGetters,
    mapActions
} from 'vuex';

import OTiles from '../../organisms/o-tiles/o-tiles';
import MVersions from '../../molecules/m-versions/m-versions';
import ABackButton from '../../atoms/a-back-button/a-back-button';
import MInputForm from '../../molecules/m-input-form/m-input-form';
import OKeyboard from '../../unique-organisms/o-keyboard/o-keyboard';
import OTTile from '../../unique-organisms/o-t-tile/o-t-tile';
import OContentHeader from '../../organisms/o-content-header/o-content-header';
import OServicesTile from '../../unique-organisms/o-services-tile/o-services-tile';

import { GUIDE_SCREEN } from '../../../utils/constants/pages';
import {
    SHOW_MODAL,
    SUCCESS_SEARCH,
    SEARCH_DATA_CHANGE
} from "../../../utils/constants/bus-events-constants";

import search from "../../../utils/mixins/search";

export default {
    name: "OSearch",
    data() {
        return {
            id: null,
            fuse: null,
            searchValue: '',
            searchEventDelay: 2000,
            searchEventTimerId: null
        }
    },
    mixins: [search],
    components: {
        OTiles,
        OKeyboard,
        OTTile,
        MVersions,
        MInputForm,
        ABackButton,
        OServicesTile,
        OContentHeader
    },
    computed: {
        ...mapState({
            mapLanguages: state => state.map.meta.languages
        }),
        ...mapGetters([
            't',
            'getMapConfigProp',
            'getTenantCategoriesRoot',
            'getDenormalisedObjectById'
        ]),
        getItems(){
            return this.searchValue ?
                this.searchValue.length >= this.numberLettersRequiredForStrictSearch ?
                    this.strictSearchResults.length ?
                        this.strictSearchResults
                        : this.isWideSearchResultShow ?
                            this.wideSearchResults
                            : []
                    :this.wideSearchResults
                : this.mergedData
        },
        /**
         * this.getMapConfigProp('features.search.unsuccessfulSearchRate', 0.6) -
         * this is the ratio of the number of deleted letters after which we consider that the search was unsuccessful
         * @return {boolean} true if search unsuccessful
         */
        isSearchStringErase() {
            return this.oldValue.length >= 2
                && (this.oldValue.length - this.searchValue.length)/this.oldValue.length >= this.getMapConfigProp('features.search.unsuccessfulSearchRate', 0.6)
        },
    },
    watch: {
        searchValue(value) {
            if(value >= this.oldValue) this.oldValue = value
            this.$nextTick(() => {
                this.$bus.$emit(SEARCH_DATA_CHANGE, {
                    searchValue: this.searchValue,
                    oldValue: this.oldValue,
                    searchResultsCount: this.getItems.length
                })
            })
        }
    },
    methods: {
        handleKeyboardClick(val) {
            this.searchValue += val;
        },
        handleDelete() {
            if(this.searchValue.length !== 0) {
                this.searchValue = this.searchValue.substring(0, this.searchValue.length - 1)
            }
        },
        redirectToGuide(data) {
            const params = {
                name: GUIDE_SCREEN,
                params: {
                    type: 'search',
                    id: data.id
                }
            };
            this.$router.push(params);
        },
        showServicesModal(data) {
            const params = {
                component: 'services',
                data: {
                    ...data
                }
            };
            this.$bus.$emit(SHOW_MODAL, params);
        },
        handleTileClick(data) {
            this.searchValue && this.$bus.$emit(SUCCESS_SEARCH, {
                value1: this.value,
                value2: "found",
                value3: "request_guide",
                target: 'object',
                target_type: data.type,
                target_id: data.id,
            })
            if (data.type === 'tenant' || data.type === 'service') this.redirectToGuide(data);
            else this.showServicesModal(data);
        },

    },
    beforeDestroy() {
        clearTimeout(this.searchEventTimerId)
    }
}
</script>

<style lang="scss">
@import "o-search";
</style>
